import React from 'react'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import GroupEventInfo from './group-event-info'
import ContactInformation from './contact-information'
import ParticipantInformation from './participant-information'
import PriceDetails from './price-details'
import SignInNudge from './sign-in-nudge'
import PaymentInformation from './payment-information'
import RegisterButton from './register-button'

const DesktopLayout = ({ groupEvent, paymentRequired, setPaymentRequired }) => {
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      py={6}
      mx={2}
      position="relative"
    >
      <Box
        mr={2}
        p={4}
        borderRadius={16}
        style={{
          backgroundColor: 'white',
          width: '525px',
          height: 'fit-content',
        }}
      >
        <SignInNudge />
        <ParticipantInformation />
        <Box mb={2}>
          <ContactInformation />
        </Box>
        <Box mb={4}>
          <PaymentInformation
            groupEvent={groupEvent}
            paymentRequired={paymentRequired}
            setPaymentRequired={setPaymentRequired}
          />
        </Box>
        <RegisterButton
          groupEvent={groupEvent}
          paymentRequired={paymentRequired}
          type="submit"
        />
      </Box>
      <Box
        p={4}
        borderRadius={16}
        style={{
          backgroundColor: 'white',
          width: '480px',
          height: 'fit-content',
          top: '48px',
        }}
        position="sticky"
      >
        <GroupEventInfo groupEvent={groupEvent} />
        <Box my={3}>
          <Divider />
        </Box>
        <PriceDetails
          groupEvent={groupEvent}
          paymentRequired={paymentRequired}
        />
      </Box>
    </Box>
  )
}

export default DesktopLayout
